import {
  importVspFile,
  selectActiveProject,
  selectActiveProjectName,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { DataToSendEvent, SelectItem } from '@core/core/types'
import { getUploadDataAnalyticParams } from '@core/core/utils'
import type { FC } from 'react'

import { AddingFilesVSPModal } from './AddingFilesVSPModal'
import { unknownFileName } from './constants'
import type { AddingFilesModalContainerPropsType as PropsType, FormDataVSPType } from './types'
import { useAddingFiles } from './useAddingFiles'

const AddingFilesVSPModalContainer: FC<PropsType> = ({ treeObject, files = null }) => {
  const dispatch = useAppDispatch()
  const { id: activeProjectId } = useAppSelector(selectActiveProject)
  const activeProjectName = useAppSelector(selectActiveProjectName)
  const data: DataToSendEvent = {
    id: 'import from file_end',
    params: getUploadDataAnalyticParams(activeProjectName, 'VSP'),
  }
  const { visibleModal, activeFileReady, onCancel, onSave } = useAddingFiles(
    files,
    data,
    (file: File, formData?: FormDataVSPType) => {
      if (formData?.wellId) {
        dispatch(
          importVspFile(
            activeProjectId,
            formData.wellId,
            formData.isNegativeZ ?? false,
            formData.isNegativeTwt ?? false,
            file,
          ),
        )
      }
    },
  )
  const wellId = treeObject?.projectEntityUid
  const wellItemsDefault: SelectItem[] = wellId ? [{ key: wellId, label: treeObject.name }] : []

  return (
    <AddingFilesVSPModal
      fileName={activeFileReady?.name ?? unknownFileName}
      objectName={treeObject?.name}
      isModalOpen={visibleModal}
      wellItems={wellItemsDefault}
      onCancel={onCancel}
      onSave={onSave}
    />
  )
}

export { AddingFilesVSPModalContainer }
